import { render, staticRenderFns } from "./CollectionSort.vue?vue&type=template&id=3e84f9e1&lang=pug&"
import script from "./CollectionSort.vue?vue&type=script&lang=js&"
export * from "./CollectionSort.vue?vue&type=script&lang=js&"
import style0 from "./CollectionSort.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e84f9e1')) {
      api.createRecord('3e84f9e1', component.options)
    } else {
      api.reload('3e84f9e1', component.options)
    }
    module.hot.accept("./CollectionSort.vue?vue&type=template&id=3e84f9e1&lang=pug&", function () {
      api.rerender('3e84f9e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/sales-flow-ui/components/CollectionSort.vue"
export default component.exports